import { render } from "./forward.vue?vue&type=template&id=f4db8228&scoped=true&ts=true"
import script from "./forward.vue?vue&type=script&lang=ts"
export * from "./forward.vue?vue&type=script&lang=ts"

import "./forward.vue?vue&type=style&index=0&id=f4db8228&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4db8228"]])

export default __exports__